<!--
Copyright 2026 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license, please see LICENSE.md in the
project root for license information.
-->
<crucible-dialog
  [dialogTitle]="(data.competency.id ? 'Edit ' : 'Add ') + (typeHint || 'Competency')"
  [submitDisabled]="!errorFree()"
  [guardUnsavedWork]="true"
  (cancel)="handleEditComplete(false)"
  (submit)="handleEditComplete(true)"
>
  @if (!!data && data.competency !== undefined && data.competency !== null) {
    <div crucibleDialogContent>
      @if (availableTypes.length > 0) {
      <div class="add-margin">
        <mat-form-field class="full-width">
          <mat-label>Type</mat-label>
          <mat-select [value]="typeHint" (selectionChange)="onTypeChange($event.value)" [disabled]="typeHintLocked">
            @for (t of availableTypes; track t) {
            <mat-option [value]="t">{{ t }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
      }
      @if (availableParents.length > 0) {
      <div class="add-margin">
        <mat-form-field class="full-width">
          <mat-label>Category</mat-label>
          <mat-select [(ngModel)]="data.competency.parentId">
            <mat-option [value]="null">None</mat-option>
            @for (p of availableParents; track p.id) {
            <mat-option [value]="p.id">{{ p.label }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
      }
      <div class="add-margin">
        <mat-form-field class="full-width">
          <mat-label>ID Number</mat-label>
          <input
            type="text"
            matInput
            placeholder="ID Number"
            [(ngModel)]="data.competency.idNumber">
        </mat-form-field>
      </div>
      <div class="add-margin">
        <mat-form-field class="full-width">
          <mat-label>Short Name</mat-label>
          <input
            type="text"
            matInput
            placeholder="Short Name"
            [(ngModel)]="data.competency.shortName">
        </mat-form-field>
      </div>
      <div class="add-margin">
        <mat-form-field class="full-width">
          <mat-label>Description</mat-label>
          <textarea
            matInput
            rows="3"
            placeholder="Description"
            [(ngModel)]="data.competency.description">
          </textarea>
        </mat-form-field>
      </div>
    </div>
  }
</crucible-dialog>
